import React from 'react';
import Box from '@mui/material/Box';
import { DialogWrapper } from './DialogWrapper.js';

const ImagePreview = ({
  src,
  alt,
  children,
  ...props
}) => {
  return /*#__PURE__*/React.createElement(Box, props, /*#__PURE__*/React.createElement(DialogWrapper, {
    showOnClick: /*#__PURE__*/React.createElement("img", {
      src: src,
      alt: alt,
      style: {
        maxHeight: "90vh",
        maxWidth: "90vw"
      }
    })
  }, /*#__PURE__*/React.createElement("img", {
    src: src,
    alt: alt,
    style: {
      width: "100%"
    }
  }), children));
};

export { ImagePreview, ImagePreview as default };
